import { toJS } from "mobx";
import JobStore from "../stores/internal/JobStore";

export const getJobsBySiteId = (site_id) => toJS(JobStore.jobs_by_site[site_id])
export const getGroupedJobsBySiteId = (site_id) => toJS(JobStore.jobs_by_site_grouped[site_id])
export const getJobForSiteById = (site_id, job_id) => {
    if (!JobStore.job_lookup_by_site[site_id]) return undefined
    return toJS(JobStore.job_lookup_by_site[site_id][job_id])
}
